export default __webpack_public_path__ + "328ba336d95f9dc635d3c5cebdc69471.png";